import React from "react";

import { formatNumberRange, formatNumericCurrency, useGetFarms, useInventoryImpact, useTranslation } from "utils";

import { SingleFieldOutcomes } from "models";

import { Flex, IconLinkButton, Tag, Tooltip } from "components";

type OutcomeBasedImpactProps = {
  isDividePerHectare: boolean;
  fieldSizes: Record<string, number>;
  reportingYear: number;
  singleFieldOutcomes: SingleFieldOutcomes[];
};

export const OutcomeBasedImpact = ({ isDividePerHectare, reportingYear, singleFieldOutcomes }: OutcomeBasedImpactProps) => {
  const { t } = useTranslation("fieldTimeline");
  const { currentFarm } = useGetFarms();

  const { totalOutcomeBasedPayoutMin, totalOutcomeBasedPayoutMax, totalOutcomePotentialPayout, isMaxOutcomePayoutReached, displayPerHectareOrTotalFarm } =
    useInventoryImpact(reportingYear, singleFieldOutcomes, currentFarm?.id ?? "", currentFarm?.carbonProgram ?? undefined);

  const displayedTotalOutcomeBasedPayoutMin = displayPerHectareOrTotalFarm(totalOutcomeBasedPayoutMin, isDividePerHectare);
  const displayedTotalOutcomeBasedPayoutMax = displayPerHectareOrTotalFarm(totalOutcomeBasedPayoutMax, isDividePerHectare);
  const displayedTotalOutcomePotentialPayout = displayPerHectareOrTotalFarm(totalOutcomePotentialPayout, isDividePerHectare);

  return (
    <>
      <div className="divider" />
      <Tooltip placement="top" title={t("impactPanel.inventory.payoutSocTitle")}>
        <IconLinkButton
          dataTestId="inventory-impact-panel-outcome-based-payout-info-icon-button"
          theme="black-grey-bold"
          iconType="info"
          size="small"
          text={t("impactPanel.inventory.outcomeBasedPayout")}
        />
      </Tooltip>
      <Flex className="margin-top-50" justify="space-between">
        {isMaxOutcomePayoutReached ? (
          <Tag
            className="maximum-payment-tag"
            dataTestId="maximum-payment-tag"
            colour="yellow"
            text={
              <Flex align="center">
                <span className="paragraph-s-bold">{t("impactPanel.inventory.maximumPaymentBadge")}</span>
              </Flex>
            }
          />
        ) : (
          <Tooltip placement="top" title={t("impactPanel.inventory.payoutSoc")}>
            <h4 className="green-text" data-testid="total-outcome-based-payout">
              {formatNumberRange({ min: displayedTotalOutcomeBasedPayoutMin, max: displayedTotalOutcomeBasedPayoutMax, decimalPlaces: 0 })}
            </h4>
          </Tooltip>
        )}
        <Tooltip placement="top" title={t("impactPanel.inventory.payoutSocPotential")}>
          <h4 className={isMaxOutcomePayoutReached ? "green-text" : "maximum-theoretical-payout"} data-testid="maximum-potential-outcome-based-payout">
            {formatNumericCurrency(displayedTotalOutcomePotentialPayout, { decimals: 0, currency: currentFarm?.carbonProgram?.currency })}
          </h4>
        </Tooltip>
      </Flex>
      <div className="divider" />
    </>
  );
};
